var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgQuestion = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M8.028 11.783q.274 0 .458.185a.62.62 0 0 1 .185.458.61.61 0 0 1-.185.451.62.62 0 0 1-.458.184.61.61 0 0 1-.45-.184.61.61 0 0 1-.185-.451q0-.274.184-.458a.61.61 0 0 1 .451-.185M8.26 3.047q1.224 0 2.01.697.794.697.793 1.75 0 .739-.362 1.306-.355.56-1.08 1.025-.67.431-.91.793-.238.356-.238.93v.512h-.91v-.642q-.006-.67.308-1.148.314-.48 1.04-.95.648-.432.915-.835.274-.403.274-.95 0-.731-.527-1.203-.526-.472-1.346-.472T6.88 4.34q-.527.478-.595 1.285h-.889q.063-1.128.82-1.853.76-.724 2.045-.724"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0m0 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1",
  clipRule: "evenodd"
})));
export default SvgQuestion;